import {
  AdvanceQualificationMethod,
  LendingPaymentSource,
} from '@varo/graphql-schema-types';
import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { TabaPayEntryFlowType } from 'features/moveMoney/screens/dcf/tabapay/helpers/TabaPay.helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

const ExpiredCard = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'linkDebitCard',
  });

  const {
    advanceAmount,
    dueDate,
    feeAmount,
    amountId,
    repaymentDate,
    selectedAccountId,
    paymentSource,
    selectedAccountName,
    qualificationMethod,
  } = useLocalSearchParams<{
    advanceAmount: string;
    dueDate: string;
    feeAmount: string;
    amountId: string;
    repaymentDate: string;
    selectedAccountId?: string;
    paymentSource?: LendingPaymentSource;
    selectedAccountName?: string;
    qualificationMethod: AdvanceQualificationMethod;
  }>();

  const handleViewCardsPressed = usePressableAnalytics({
    analyticsId: 'updateCardClicked',
  });

  const handleOnPress = () => {
    {
      router.dismissTo({
        pathname: '/myvaro/external-accounts',
        params: {
          tabaPayEntryFlowType: TabaPayEntryFlowType.VaApplication,
          advanceAmount,
          dueDate,
          feeAmount,
          amountId,
          repaymentDate,
          selectedAccountId,
          paymentSource,
          selectedAccountName,
          qualificationMethod,
        },
      });
    }
  };

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
          headerBackVisible: false,
          title: '',
        }}
      />
      <ScreenTransitionOverlay
        isLoading={false}
        LoadingComponent={
          <LoadingSpinner accessibilityLabel="loading indicator auto-payment" />
        }
        ErrorComponent={
          <ErrorScreen
            screenType={ErrorScreenType.Error}
            messageHeadline={translatedText('expiredCardTitle')}
            messageBody={translatedText('expiredCardMessage')}
            primaryButton={{
              title: translatedText('viewCards'),
              onPress: () => {
                handleViewCardsPressed();
                handleOnPress();
              },
            }}
          />
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default ExpiredCard;
